export const FetchMaintenancesQuery = (propertyIds, unitIds, maintenanceIds, status, category, offset) => {
  offset = offset == null? "": offset; 
  maintenanceIds = maintenanceIds == null? []: maintenanceIds;
  const query = `
    query{
        propertyMaintenances(propertyIds:${JSON.stringify(propertyIds)}, unitIds:${JSON.stringify(unitIds)},
        maintenanceIds:${JSON.stringify(maintenanceIds)},
        status:${JSON.stringify(status)}, category:${JSON.stringify(category)}, offset:"${offset}", limit:50){
          maintenances{
            id
            property{id}
            unit{id}
            category
            status
            shortSummary
            description
            createdTs
            isCreatedByLandlord
            upload{
              id
              file
            }
            expense{
              id
            }
          }
          next
          previous
          summary{
            header,
            body,
            footer
          }
        }
      }
    `
    return query
  }

export const AddMaintenancesMutation = (propertyId, unitId, status, category, shortSummary, description, createExpense, expenseAmount) => {
const mutation = `
mutation($file: Upload){
    addMaintenance(
      propertyId:${JSON.stringify(propertyId)},unitId:${JSON.stringify(unitId)}, category:"${category}", status:"${status}", 
      shortSummary:${JSON.stringify(shortSummary)}, description:${JSON.stringify(description)},
      createExpense: ${createExpense}, expenseAmount: ${expenseAmount},
      fileUpload: $file
    ){
        maintenance{
        id
        property{id}
        unit{id}
        category
        status
        shortSummary
        description
        createdTs
        isCreatedByLandlord
        expense{
          id
        }
        upload{
          id
          file
        }
        }
        errorMessage
    }
    }
`
return mutation
}

export const UpdateMaintenancesMutation = (maintenanceId,propertyId, unitId, status, category, shortSummary, description, updateFile=false) => {
    const mutation = `
    mutation($file: Upload){
        updateMaintenance(
          maintenanceId:${JSON.stringify(maintenanceId)},propertyId:${JSON.stringify(propertyId)},unitId:${JSON.stringify(unitId)}, 
          category:"${category}", status:"${status}", 
          shortSummary:${JSON.stringify(shortSummary)}, description:${JSON.stringify(description)},
          updateFile: ${updateFile}, fileUpload: $file
        ){
            maintenance{
            id
            property{id}
            unit{id}
            category
            status
            shortSummary
            description
            createdTs
            isCreatedByLandlord
            expense{
              id
            }
            upload{
              id
              file
            }
            }
            errorMessage
        }
        }
    `
    return mutation
    }

export const DeleteMaintenanceMutation = (maintenanceId) => {
    const mutation = `
    mutation{
        deleteMaintenance(maintenanceId:${JSON.stringify(maintenanceId)}){
         success
        }
      }
    `
    return mutation
}